export {default as Application} from './Application.jsx';
export {default as MainPage} from './pages/MainPage.jsx';

export {default as BironexPage} from './pages/BironexPage.jsx';
export {default as SportsPage} from './pages/SportsPage.jsx';
export {default as LivePage} from './pages/LivePage.jsx';
export {default as BetGamesPage} from './pages/BetGamesPage.jsx';
export {default as SlotsGamesPage} from './games/slots/index.js';
export {default as VirtualGamesPage} from './games/virtual-sports';
export {default as SignInPage} from './pages/SignIn.jsx';
export {default as SignUpPage} from './pages/SignUp.jsx';
export {default as IdentifyPage} from './pages/IdentifyPage.jsx';
export {default as CybersportPage} from './pages/Cybersport.jsx';
export {default as GamesNewPage} from './pages/GamesPageNewLayout/GamesPageNew.jsx'
export {default as Footer} from './Footer.jsx';



// WEBPACK FOOTER //
// ./js/sport-betting/components/index.js